var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.5 38.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #222221;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.25,38.5C8.64,38.5,0,29.86,0,19.25S8.64,0,19.25,0s19.25,8.64,19.25,19.25-8.64,19.25-19.25,19.25Zm0-37C9.46,1.5,1.5,9.46,1.5,19.25s7.96,17.75,17.75,17.75,17.75-7.96,17.75-17.75S29.04,1.5,19.25,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.64,18.73h-9.14v2.62h6.17c-.73,3.19-2.98,5.14-6,5.14-3.96,0-7.17-3.21-7.17-7.17s3.21-7.17,7.17-7.17c1.88,0,3.59.73,4.87,1.91l2.02-1.74c-1.77-1.75-4.21-2.83-6.89-2.83-5.43,0-9.82,4.4-9.82,9.82s4.4,9.82,9.82,9.82,8.98-3.97,8.98-9.4l-.02-1.01Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.773f11eb0942233366327c5aa99b4033.svg";
export { ForwardRef as ReactComponent };